import { Video } from '../types/content';
import { images } from './images';

// Add each video's YouTube ID to embed the player directly on the page.
export const videos: Video[] = [
  { id: 'v1', title: 'PowerTrip Pit Ticket Give Away Drawing, at Trip Ink Tattoo Company', poster: images.vegasNeon, youtubeId: '' },
  { id: 'v2', title: 'Trip Ink Tattoo Company Commercial', poster: images.hero, youtubeId: '' },
  { id: 'v3', title: 'Rick Trip and Trip Ink Tattoo Company', poster: images.rick, youtubeId: '' },
  { id: 'v4', title: 'Rick Trip tattooing Ivan Moody of FFDP!', poster: images.knight, youtubeId: '' },
];
